import React from 'react';
import { Link } from 'react-router-dom';
import './ComingSoon.css';

function ComingSoon() {
  return (
    <div className="coming-soon-page">
      <div className="coming-soon-background" style={{ backgroundImage: `url('/images/coming_soon_bg.png')` }}>
        <div className="coming-soon-overlay"></div>
        <h1 className="coming-soon-text">Coming Soon</h1>
        <Link to="/" className="back-home-btn">Return Home</Link>
      </div>
    </div>
  );
}

export default ComingSoon;
